import InformationColorImageColor from "./informationColor0.png";
import InformationColorImageBw from "./informationColor1.png";

export const InformationColorImage = {
  Color: InformationColorImageColor,
  Bw: InformationColorImageBw,
};
